/**
 * Shared TipTap table extension configuration used by every rich text editor
 * in landing-page-v2 (SimpleRichTextEditor, InlineTipTapEdit, EmailBodyEditor).
 *
 * The `tiptap-table` class is a contract with `SanitizedHtml`'s class allowlist
 * and `globals.scss`'s `table.tiptap-table` styles — change it here and only
 * here.
 */

import { Table } from "@tiptap/extension-table";
import { TableRow } from "@tiptap/extension-table-row";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableCell } from "@tiptap/extension-table-cell";

/** CSS class applied to every TipTap-emitted `<table>` element. */
export const TIPTAP_TABLE_CLASS = "tiptap-table";

/** Initial dimensions when inserting a new table from the toolbar dropdown. */
export const DEFAULT_TABLE_ROWS = 3;
export const DEFAULT_TABLE_COLS = 3;

/**
 * The four TipTap extensions needed to render and edit tables.
 * Spread into the `extensions` array of any `useEditor` call that should
 * support tables.
 */
export const TABLE_EXTENSIONS = [
  Table.configure({ resizable: true, HTMLAttributes: { class: TIPTAP_TABLE_CLASS } }),
  TableRow,
  TableHeader,
  TableCell,
];
